export const DATE_TIME_FORMAT = {
  MMM_D_YYYY: 'MMM D, YYYY',
  MM_DD_YYYY: 'MM/DD/YYYY',
  MM_DD_YYYY_hh_mm_A: 'MM/DD/YYYY, hh:mm A',
  YYYY_MM_DD_DASH: 'YYYY-MM-DD',
  h_mm_A: 'h:mm A',
  MMMM_Do_YYYY: 'MMMM Do YYYY',
  MMMM_DD_YYYY: 'MMMM DD, YYYY',
};
